const selectors = {
	container: ".rt-more-info-container",
	button: ".rt-more-info-btn",
	content: ".rt-more-info-content",
	main: "#rt-page-container",
};
const hiddenClass = "hidden";
/** Add tooltips to the page */
export function initializeMoreInfoBlocks(): void {
	const observerOptions = {
		childList: true,
		subtree: true,
	};
	const elementToWatch = document.querySelector(selectors.main);
	if (!elementToWatch) {
		return;
	}
	const observer = new MutationObserver((e) => handleMutation(e));
	observer.observe(elementToWatch, observerOptions);
}

/**
 * Handle mutations to the main content area
 *
 * @param e The mutation record
 */
function handleMutation(e: MutationRecord[]): void {
	if (e.some((mutation) => mutation.type === "childList")) {
		setupPage();
	}
}

/** Set up the page for more info functionality */
function setupPage() {
	hideExplanations();
	addToolTips();
}
/** Add tooltips to the page */
function addToolTips() {
	const tooltipButtons = Array.from<HTMLElement>(
		document.querySelectorAll(selectors.button),
	);
	tooltipButtons.forEach((element) => {
		addToolTip(element);
	});
}

/** Hide all explanations */
function hideExplanations() {
	const explanations = Array.from<HTMLElement>(
		document.querySelectorAll(selectors.content),
	);
	explanations.forEach((element) => {
		element.classList.add(hiddenClass);
	});
}
/**
 * Add a tooltip to an element
 *
 * @param element The element to add the tooltip to
 */
function addToolTip(element: HTMLElement) {
	const { id, loaded } = element.dataset;
	if (!id || loaded) return;
	const tipArea = document.querySelector(`div[data-id="${id}"]`);
	if (!tipArea) return;
	element.dataset.loaded = "true";
	element.addEventListener("click", () => handleTooltipClick(tipArea));
}
/**
 * Handle a click on a tooltip
 *
 * @param element The element that was clicked
 */
function handleTooltipClick(element: Element) {
	element.classList.toggle(hiddenClass);
}
